module.exports = __webpack_public_path__ + "img/icon-total-member.ed88aa0d.png";